<style lang="scss">
</style>

<script>
  import { teamStore } from "../../../../../api-stores/license-store";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import { groupIdsStore } from "../stores";
</script>

<MultiSelectDropdown
  label="Groups"
  items={Object.entries($teamStore.teamGroups).map(([id, group]) => ({
    id,
    label: group.groupName,
  }))}
  showFilter={false}
  bind:selectedItems={$groupIdsStore}
  placeholder="Select groups"
/>
